export default __webpack_public_path__ + "locales/bg/FillPDFDialog.json?hash=0ca6d5c972ea186bc6f5c8e687a20e31";